import queryStirng from 'query-string';
import "./Room.scoped.scss";
import RoomChatting from "../components/Room/Chatting/RoomChatting";
import RoomHeader from "../components/Room/RoomHeader";
import Members from "../components/Room/Members";
import { RouteComponentProps } from "react-router-dom";
import { useEffect, useState } from "react";
import emitJoinRoom from "../connector/emits/joinRoom";
import { useRecoilState } from "recoil";
import roomState from "../atoms/room";
import emitGetUsers from "../connector/emits/getUsers";
import emitGetMessages from "../connector/emits/getMessages";
import participantsState from "../atoms/participants";
import emitGetUserDetails from "../connector/emits/getUserDetails";
import emitGetMyInfo from "../connector/emits/getMyInfo";
import roomDetailState from '../atoms/roomDetail';
import emitGetRoomDetail from '../connector/emits/getRoomDetail';
import moment from 'moment';
import Picks from '../components/Room/Picks';
import axios from 'axios';
import environment from '../environment';
import emitGetProjectTypes from '../connector/emits/getProjectTypes';
import emitGetIsKick from '../connector/emits/getIsKick';
import { getRecoil, setRecoil } from 'recoil-nexus';
import { openAlert, userBoxState } from '../atoms/common';
import emitFreezeUser from '../connector/emits/freezeUser';
import emitKickUser from '../connector/emits/kickUser';
import emitAppointManager from '../connector/emits/appointManager';
import emitDisappointManager from '../connector/emits/disappointManager';
import myInfoState from '../atoms/myinfo';

interface MatchParams {
  id: string;
}

const getParentByClass = (el: any, className: string) => {
  do {
    if (el.classList.contains(className)) {
      return el;
    } else {
      el = el.parentNode;
    }
  } while (el && el.parentNode)
}

const Room: React.FunctionComponent<RouteComponentProps<MatchParams>> = (
  { match, location }
) => {
  const roomId = match.params.id;

  const [room] = useRecoilState(roomState);
  const [roomDetail] = useRecoilState(roomDetailState);
  const [myInfo] = useRecoilState(myInfoState);
  const [participants] = useRecoilState(participantsState);

  const [selectedMembersTab, setSelectedMembersTab] = useState('members');
  const [userBox] = useRecoilState(userBoxState);

  // const updateRemainNextRound = () => {
  //   axios.get(`${environment.SERVER_URL}/sabong/api/current-round.php`)
  //     .then(({ data }) => {
  //       const nextRound = Number((data as { fullRound: string }).fullRound) + 1;
  //       window.document.getElementById('nextRound')!.innerHTML = `${nextRound}`;

  //       const remainSecond = Math.ceil((300000 - ((new Date()).getTime() + 25000) % 300000) / 1000);
  //       window.document.getElementById('remainNextRound')!.innerHTML =
  //         `${Math.floor(remainSecond / 60)}분 ${remainSecond % 60}초`;
  //     });
  // };

  // useEffect(() => {
    // updateRemainNextRound();
    // setInterval(updateRemainNextRound, 1000);
  // });

  useEffect(() => {
    const clickEvent = (e: MouseEvent) => {
      const el = e.target;
      const found1 = getParentByClass(el, 'user-box');
      const found2 = getParentByClass(el, 'no-close-user-box');
      if (found1 || found2) {
        // No action
      } else {
        const newUserBox = { ...getRecoil(userBoxState) };
        newUserBox.display = false;
        setRecoil(userBoxState, newUserBox);
      }
    };

    // eslint-disable-next-line no-restricted-globals
    addEventListener('click', clickEvent);

    setTimeout(() => {
      const roomDetail = getRecoil(roomDetailState);
      if (!roomDetail.id.trim()) {
        openAlert('이미 삭제된 방이므로, 대기실로 이동합니다.', () => window.location.href = '/chatting-app/waiting-room');
      } else {
        console.info(roomDetail.id);
      }
    }, 500);
    return () => {
      // eslint-disable-next-line no-restricted-globals
      removeEventListener('click', clickEvent);
    }
  }, []);

  useEffect(() => {
    const query = queryStirng.parse(location.search);
    emitJoinRoom(roomId, (query.password ?? '') as string);
    emitGetMyInfo();
  }, [location.search, roomId]);

  useEffect(() => {
    emitGetProjectTypes();
    emitGetRoomDetail(roomId);
    emitGetUsers(roomId);
    emitGetMessages(roomId);
    setInterval(() => {
      emitGetRoomDetail(roomId);
      emitGetIsKick(roomId);
    }, 1000);
    emitGetIsKick(roomId);
  }, [room.isJoin, roomId]);

  useEffect(() => {
    emitGetUserDetails(participants.users);
  }, [participants.users]);

  const users = participants.users.filter((v, i, a) => a.indexOf(v) === i);

  const thumbnailUrlTailer = Math.floor(moment().unix() / 60);
  const thumbnailUrl = roomDetail.ownerDetail?.hasThumbnail
      ? `/data/member_image/${roomDetail.owner.substring(0, 2)}/${roomDetail.owner}.gif?${thumbnailUrlTailer}`
      : '/img/profile.png';

  const closeUserBox = () => {
    const newUserBox = { ...getRecoil(userBoxState) };
    newUserBox.display = false;
    setRecoil(userBoxState, newUserBox);
  }

  const runFreeze = () => {
    emitFreezeUser(userBox.userId);
    closeUserBox();
  };

  const runKick = () => {
    emitKickUser(userBox.userId);
    closeUserBox();
  };

  const appointManager = () => {
    emitAppointManager(userBox.userId);
    closeUserBox();
  };

  const disappointManager = () => {
    emitDisappointManager(userBox.userId);
    closeUserBox();
  };

  return (
    <>
      <div className="room">
        <RoomHeader 
          thumbnailUrl={thumbnailUrl}
          roomName={roomDetail.name}
          ownerNickname={roomDetail.ownerDetail?.nickname}
          participants={users.length}
        />
        <div className="room__contents">
          <div className="room__chatting">
            <RoomChatting />
          </div>
          <div className="room__members">
{/*            <div className="room__members-remain-next-round">
              <b id="remainNextRound">0분 00초</b> 후 <b id="nextRound">0</b> 회차 결과 발표
            </div>*/}
            <div className="room__members-tab-select">
              <button
                className={`${selectedMembersTab === 'members' ? 'active' : ''}`}
                onClick={() => setSelectedMembersTab('members')}
              >
                👪접속자 목록
              </button>
             <button
                className={`${selectedMembersTab === 'picks' ? 'active' : ''}`}
                onClick={() => setSelectedMembersTab('picks')}
              >
                🫅방장픽 목록
              </button>
            </div>
            {
              selectedMembersTab === 'members'
                ? (<Members />)
                : (<Picks />)
            }
          </div>
        </div>
      </div>
      <div className="popup-footer">
        Copyright ⓒ <strong style={{color: '#127ccb'}}>동행파워볼게임</strong> All Rights Reserved.
      </div>

      <div style={{
        backgroundColor: 'white',
        width: 130,
        position: 'fixed',
        top: userBox.y,
        left: userBox.x,
        display: (
          userBox.display && userBox.userId !== myInfo.id && myInfo.id
          ) ? 'block' : 'none',
      }} className='user-box'>
        <div style={{
          background: '#414141',
          color: 'white',
          padding: 5,
        }}>{userBox.userName}</div>
        {
          (myInfo.id === 'admin' || roomDetail.owner === myInfo.id || roomDetail.managers.includes(myInfo.id)) &&
          !((roomDetail.managers.includes(myInfo.id) && roomDetail.managers.includes(userBox.userId)) || userBox.userId === 'admin')
          ? (
            <>
            <div style={{
              cursor: 'pointer',
              background: '#d9d9d9',
              padding: 5,
            }} onClick={runFreeze}>벙어리</div>
            <div style={{
              cursor: 'pointer',
              background: '#d9d9d9',
              padding: 5,
            }} onClick={runKick}>강제퇴장</div>
            {myInfo.id === roomDetail.owner ? (
              !roomDetail.managers.includes(userBox.userId) ? (
                <div style={{
                  cursor: 'pointer',
                  background: '#d9d9d9',
                  padding: 5,
                }} onClick={appointManager}>매니저 임명</div>
              ) : (
                <div style={{
                  cursor: 'pointer',
                  background: '#d9d9d9',
                  padding: 5,
                }} onClick={disappointManager}>매니저 해제</div>
              )
            ) : null}
            </>
          )
          : null
        }
        <div style={{
          cursor: 'pointer',
          background: '#d9d9d9',
          padding: 5,
        }} onClick={() => {
          window.open(`/chat-one-on-one/?partner=${userBox.userId}`, "_blank", "width=440,height=496");
        }}>1:1 채팅</div>
      </div>
    </>
  );
}

export default Room;
